<p>manage-badge works!</p>
